export default __webpack_public_path__ + "static/media/person-7.2fd93341.png";